import { render } from "./ComorbiditiesView.vue?vue&type=template&id=29843ba6&scoped=true"
import script from "./ComorbiditiesView.vue?vue&type=script&lang=js"
export * from "./ComorbiditiesView.vue?vue&type=script&lang=js"

import "./ComorbiditiesView.vue?vue&type=style&index=0&id=29843ba6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29843ba6"]])

export default __exports__